export const BASE_URL = 'https://dev-backend.lenatransport.co.uk';
export const IMAGE_BASE_URL = BASE_URL;
